<template>
  <div>
    <svg
      width="24"
      height="23"
    >
      <g :transform="`translate(10, ${translateY})`">
        <path :d="linePath" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    up: {
      type: Boolean,
      required: true
    }
  },
  setup (props) {
    const radius = 12
    const length = 12

    function getLinePath () {
      const move = `M0,${props.up ? radius : 0}`
      const arc = `a${radius},${radius} 0 0 ${props.up ? 1 : 0} ${radius},${props.up ? -radius : radius}`
      const horizontalLine = `h${length}`
      return move + arc + horizontalLine
    }

    return {
      translateY: props.up ? 11 : 0,
      linePath: getLinePath()
    }
  }
}
</script>

<style lang="less" scoped>
svg {
  display: block;
}

path {
  fill: none;
  stroke: #B0BEC5;
  stroke-width: 2px;
}
</style>
